import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'tab-general',
  templateUrl: './tab-general.component.html'
})
export class TabGeneralComponent {
  @Input() public groupForm: FormGroup;
  @Input() public disabledOrViewMode: boolean;

  constructor() { }
}
